import Armor from "./armor";
import Glyphs from "../glyphs";

class Armors {
  static leather() {
    return Armor.make(
      Glyphs.LeatherArmor,
      "Leather Armor",
      "The breastplate is made from hardened boiled leather.",
      1,
      "Austere"
    );
  }

  static hornedHelm() {
    return Armor.make(
      Glyphs.HornedHelm,
      "Horned Helm",
      "A riven-metal cap with fearsome curling horns.",
      1,
      "Barbarian"
    );
  }

  static chainmail() {
    return Armor.make(
      Glyphs.Chainmail,
      "Chainmail",
      "The interlocking metal rings protect against slashing.",
      2,
      "Warlike"
    );
  }
}

export default Armors;
